import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/globe-2.vue
var s = {
	name: "DtIconGlobe2",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--globe-2"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Globe 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1.612 5H2.5A1.5 1.5 0 0 1 4 6.5V7a.5.5 0 0 0 .5.5A1.5 1.5 0 0 1 6 9v1.5c.344 0 .678-.039 1-.111V8.5A1.5 1.5 0 0 1 8.5 7h1.889a4.513 4.513 0 0 0-.145-2.5H9a.5.5 0 0 0-.5.5 1.5 1.5 0 0 1-3 0 .5.5 0 0 0-.49-.5 2 2 0 0 1-1.982-1.334A.5.5 0 0 1 3 3v-.354A4.497 4.497 0 0 0 1.612 5Zm2.387-3.032L4 2v.906A1 1 0 0 0 5 3.5 1.5 1.5 0 0 1 6.5 5a.5.5 0 0 0 1 0A1.5 1.5 0 0 1 9 3.5h.742A4.496 4.496 0 0 0 6 1.5c-.719 0-1.398.169-2.001.468ZM10.032 8H8.5a.5.5 0 0 0-.5.5v1.532A4.519 4.519 0 0 0 10.032 8Zm-4.417 3.487a5.5 5.5 0 1 0-.323-.032.5.5 0 0 0 .323.032ZM5 10.389A4.502 4.502 0 0 1 1.5 6h1a.5.5 0 0 1 .5.5V7a1.5 1.5 0 0 0 1.5 1.5.5.5 0 0 1 .5.5v1.389Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=globe-2.js.map